import { type ReactElement } from 'react';

const renderBranch = (
  condition: boolean | Function,
  right: ReactElement | null = null,
  left: ReactElement | null = null
): ReactElement | null => {
  const isRight = typeof condition === 'function' ? condition() : condition;

  return isRight ? right : left;
};

export default renderBranch;
